// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"489":"9bfd386a","1275":"9bfd386a","1406":"9bfd386a","4866":"9bfd386a","5797":"9bfd386a","8541":"9bfd386a"}[chunkId] + ".chunk.css";
};